var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgBeautyAlert = function SvgBeautyAlert(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 49,
    viewBox: "0 0 56 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2004_60179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.26676 48.5C2.77787 48.5 2.33342 48.3778 1.93342 48.1333C1.53342 47.8889 1.22231 47.5667 1.00009 47.1667C0.777868 46.7667 0.655646 46.3333 0.633423 45.8667C0.611201 45.4 0.733424 44.9444 1.00009 44.5L25.6668 1.83333C25.9334 1.38889 26.2779 1.05556 26.7001 0.833333C27.1223 0.611111 27.5556 0.5 28.0001 0.5C28.4445 0.5 28.8779 0.611111 29.3001 0.833333C29.7223 1.05556 30.0668 1.38889 30.3334 1.83333L55.0001 44.5C55.2668 44.9444 55.389 45.4 55.3668 45.8667C55.3445 46.3333 55.2223 46.7667 55.0001 47.1667C54.7779 47.5667 54.4668 47.8889 54.0668 48.1333C53.6668 48.3778 53.2223 48.5 52.7334 48.5H3.26676Z",
    fill: "#FFCC7A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6305 40.5013C29.3861 40.5013 30.0194 40.2457 30.5305 39.7346C31.0416 39.2235 31.2972 38.5902 31.2972 37.8346C31.2972 37.0791 31.0416 36.4457 30.5305 35.9346C30.0194 35.4235 29.3861 35.168 28.6305 35.168C27.875 35.168 27.2416 35.4235 26.7305 35.9346C26.2194 36.4457 25.9639 37.0791 25.9639 37.8346C25.9639 38.5902 26.2194 39.2235 26.7305 39.7346C27.2416 40.2457 27.875 40.5013 28.6305 40.5013ZM28.6305 32.5013C29.3861 32.5013 30.0194 32.2457 30.5305 31.7346C31.0416 31.2235 31.2972 30.5902 31.2972 29.8346V21.8346C31.2972 21.0791 31.0416 20.4457 30.5305 19.9346C30.0194 19.4235 29.3861 19.168 28.6305 19.168C27.875 19.168 27.2416 19.4235 26.7305 19.9346C26.2194 20.4457 25.9639 21.0791 25.9639 21.8346V29.8346C25.9639 30.5902 26.2194 31.2235 26.7305 31.7346C27.2416 32.2457 27.875 32.5013 28.6305 32.5013Z",
    fill: "#E08A00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2004_60179",
    x: 0.630859,
    y: 0.5,
    width: 54.7383,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2004_60179"
  })))));
};
export default SvgBeautyAlert;